<div class="circle" [style.width.px]="dimensionCircle" [style.height.px]="dimensionCircle" data-toggle="tooltip" [title]="usernameValue" [ngStyle]="{'background-color': avatarColor}">
    <div class="initials" [style.fontSize.px]="fontSize">
        {{ userInitials }}
    </div>
</div>
